import Application from "../../Application";
import IndexTypePresenter, {
  IIndexTypePresenter
} from "../presenter/IndexTypePresenter";
import GetAllIndexTypesInteractor from "./GetAllIndexTypesInteractor";

export default class ShowIndexTypesInteractor {
  private application: Application;
  private output?: IIndexTypePresenter;
  private getAllIndexTypesInteractor: GetAllIndexTypesInteractor;

  constructor({ application, getAllIndexTypes }: any) {
    this.application = application;
    this.getAllIndexTypesInteractor = getAllIndexTypes;
  }

  private async getAllTypes() {
    return this.getAllIndexTypesInteractor.execute();
  }

  execute() {
    this.output = IndexTypePresenter({
      application: this.application,
      initialState: {
        indexTypes: [],
        createModalVisible: false
      }
    });
    this.getAllTypes().then(this.output.loadAllIndexTypes);
    return this.output;
  }
}
